import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicSalesResponse } from '@web/shared/module/shop';

@jsonObject
export class PublicBoxResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(PublicSalesResponse)
  public readonly sales!: PublicSalesResponse;

  @jsonMember(Number)
  public readonly rating!: number;

  @jsonMember(Number)
  public readonly numberOfRatings!: number;

  @jsonMember(Date)
  public readonly publishedAt!: Date;

  @jsonMember(MultimediaResponse)
  public readonly logo!: MultimediaResponse;
}
